import * as PropTypes from 'prop-types';
import Button from 'antd/lib/button';
import Alert from 'antd/lib/alert';
import { FormattedMessage, useIntl } from 'react-intl';

import { EditorField } from 'modules/forms';

const PartnersForm = ({ handleSubmit, submitting, error }) => {
    const intl = useIntl();
    return (
        <form onSubmit={handleSubmit}>
            {error && <Alert type="error" message={intl.formatMessage({ id: error })} />}
            <EditorField name="value" />
            <Button loading={submitting} htmlType="submit" type="primary">
                <FormattedMessage id="partners.form.button" />
            </Button>
        </form>
    );
};

PartnersForm.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    error: PropTypes.string,
};

PartnersForm.defaultProps = {
    error: null,
};

export default PartnersForm;
